import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DateTimeService } from './date-time.service';

@Injectable({
  providedIn: 'root'
})

export class BilldozerService {

  private currentDate: string[];
  private headers: any;
  private json;

  public toPost: object;

  constructor(
    private date: DateTimeService,
    private http: HttpClient
  ) {
    this.currentDate = this.date.returnTime();
  }

  public createPostData(
    address: string,
    cell: string,
    city: string,
    email: string,
    id: number,
    name: string,
    postalCode: string,
    province: string,
    surname: string
  ): object {

    const myObject: object =  {
      legalEntity: false,
      accountNumber: 'ROB001',
      title: 'Mr',
      initials: 'RJ',
      firstName: name,
      lastName: surname,
      name: name + ' ' + surname,
      openBalance: 100.00,
      openBalanceDate: this.currentDate[0] + 'T' + this.currentDate[1] + 'UTC',
      dob: '1975-03-13T00:00:00UTC',
      occupation: '',
      gender: 'M',
      identityNumber: id,
      emailAddress: email,
      companyName: null,
      tradingAsName: null,
      vatNumber: null,
      flag: '',
      flag2: '',
      registrationNumber: null,
      notifyEmail: true,
      clientTelephones: [{
        type: 'MOBILE',
        number: cell,
        description: ''
      }],
      clientAddresses: [{
        type: 'STREET',
        line1: address,
        line2: '',
        line3: city,
        line4: '',
        city: province,
        postCode: postalCode,
        country: 'ZA',
        gps: ''
      }],
      additionalProperties: {
        updateIfExistingClient: true
      },
      testMode: false
    }

    this.toPost = myObject;
    return myObject;
  }

  public post(entryPoint, toPost) {
    return this.http.post(entryPoint, toPost).toPromise().then((data: any) => {
      console.log(data);
      this.json = JSON.stringify(data.json);
      console.log(this.json);
    });
  }

  public get(entryPoint) {
    return this.http.get(entryPoint)
      .subscribe(client => {
        console.log('Client', client);
      });
  }

  private extractData(res: Response) {
    const body = res;
    return body || {};
  }
}
